/*
 * @Description: 问题文章
 * @Author: your name
 * @Date: 2021-08-04 17:21:44
 * @LastEditTime: 2021-08-09 21:28:04
 * @LastEditors: Yeung
 * @Description: In User Settings Edit
 */
import http from "@/plugin/axios";
// import { Apis } from '../index';
import { getSubName } from "@/utils/getHost";
export default {
  /**
   * 全部文章
   */
  getArticleList: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.systemSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.systemSource = 7;
    }
    return http.post("wxApplet/article/getArticleList", data);
  },
  /**
   * 单个文章详情
   */
  getArticleDetail: (data: any): Promise<any> => {
    return http.post("wxApplet/article/getArticleDetail", data);
  },
  /**
   * pc—推荐模板
   */
  getVoteRecommendList: (data: any): Promise<any> => {
    return http.post("/activity/vote/getVoteRecommendList", data);
  },
  /**
   * pc--热门文章列表
   */
  getArticleHotList: (data: any): Promise<any> => {
    return http.post("/wxApplet/article/getArticleHotList", data);
  },
  /**
   * pc—文章有用+1
   */
  getArticleUseful: (data: any): Promise<any> => {
    return http.post("/wxApplet/article/getArticleUseful", data);
  },
  /**
   * pc--文章无帮助+1
   */
  getArticleUseless: (data: any): Promise<any> => {
    return http.post("/wxApplet/article/getArticleUseless", data);
  },
  /**
   * pc--活动方案分类个数
   */
  getArticleCount: (data: any): Promise<any> => {
    return http.post("wxApplet/article/getArticleCount", data);
  },
  /**
   * pc--文章分类子项list
   */
  getArticleByTypeList: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.systemSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.systemSource = 7;
    }
    return http.post("wxApplet/article/getArticleByTypeList", data);
  },
  /**
   * 查询文章标题
   */
  getArticleByTitleList: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.systemSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.systemSource = 7;
    }
    return http.post("/wxApplet/article/getArticleByTitleList", data);
  },
  /**
   * 精选文档
   */
  getArticleByReadList: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.systemSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.systemSource = 7;
    }
    return http.post("/wxApplet/article/getArticleByReadList", data);
  },
};
